import { Flex, Image, Box, Paragraph, Link } from 'roo-ui/components';
import { HOTELS_SEARCH_URL } from 'config/constants';
import { imageEmptyBookingsSvg } from 'images';

const NoUpcomingBookings = () => (
  <Flex flexDirection={['column', 'row']} alignItems={['center', 'flex-start']} mb={[5, 12]}>
    <Image src={imageEmptyBookingsSvg} alt="Empty Booking List" size={64} mr={[0, 6]} mb={[6, 0]} />
    <Box textAlign={['center', 'left']} px={[6, 0]}>
      <Paragraph fontSize={['base', 'lg']} mb={[4, 2]}>
        You haven’t booked a hotel yet.
        <br />
        <Link href={HOTELS_SEARCH_URL}>Find a hotel</Link> when you’re ready to plan your next trip.
      </Paragraph>
    </Box>
  </Flex>
);

export default NoUpcomingBookings;
